module.exports = __webpack_public_path__ + "static/media/12.d06ce886.png";